const constants = {
  USER_LOCATION: "userLocation",
  MAP_MARKERS: "mapMarkers"
};
const breakpoints = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 1024,
  xl: 1250
};
const matchBreakpoint = (value, maxMin) => {
  const media = window.matchMedia(`(${maxMin}-width: ${value}px)`);

  if (media.matches) {
    return true;
  }

  return false;
};

const slickItemsCounter = (event, slick, currentSlide, nextSlide) => {
  if (!slick.$dots) {
    return;
  }

  const { slidesToScroll } = slick.options;
  const dotChildrensCount = slick.$dots[0].children.length;
  const counterBox = $(".c-box-top-products__counter");
  let i = (currentSlide ? currentSlide : 0) + 1;

  if (slidesToScroll > 1) {
    i = Math.round(
      (currentSlide ? currentSlide : dotChildrensCount) / dotChildrensCount
    );
  }

  counterBox.text(`${i} z ${dotChildrensCount}`);
};

const removeLocalStorageItem = item => localStorage.removeItem(item);
const getLocalStorage = field => {
  const storage = JSON.parse(localStorage.getItem(field));

  return storage;
};

const fethLocation = (url, by) => {
  const searchBy = {
    LATLNG: "latlng",
    ARRDESS: "address",
    MARKERS: "markers"
  };
  const promise = new Promise(function(resolve, reject) {
    resolve(
      fetch(url, {
        method: "GET"
      })
        .then(response => response.json())
        .then(json => {
          const { status } = json;

          if (status !== "OK") {
            return;
          }

          if (searchBy.LATLNG === by) {
            const {
              plus_code: { compound_code: locationCity }
            } = json;

            return locationCity.substr(7).trim();
          } else if (searchBy.ARRDESS === by) {
            const {
              results: {
                0: {
                  formatted_address: formattedAddress,
                  geometry: {
                    location: { lat, lng }
                  }
                }
              }
            } = json;

            return { formattedAddress, lat, lng };
          } else if (searchBy.MARKERS === by) {
            return json;
          }
        })
        .catch(err => err)
    );
  });

  return promise;
};

const showLocationForm = () => $("[data-location-form]").slideDown(200);
const closeLocationForm = () => $("[data-location-form]").slideUp(200);
const closeLocationBlock = () => {
  const locationInfoContainer = $("[data-location-show-info]");

  removeLocalStorageItem(constants.USER_LOCATION);

  locationInfoContainer.slideUp(200);

  showLocationForm();
};

const openLocationBlock = ({ locationName }) => {
  const locationInfoContainer = $("[data-location-show-info]");
  const locationInfoLocationName = $("[data-location-name]");

  if (locationInfoLocationName.length) {
    locationInfoLocationName.text(locationName);
  }

  closeLocationForm();

  locationInfoContainer.slideDown(200);
};

const setUserLocationByCords = (lat, lng) => {
  const fetchUrl = `${process.env.GOOGLE_GEOCODE_LINK}?latlng=${lat},${lng}&sensor=true&key=${process.env.GOOGLE_API_KEY}`;

  fethLocation(fetchUrl, "latlng").then(respond => {
    localStorage.setItem(
      constants.USER_LOCATION,
      JSON.stringify({
        locationName: respond,
        lat,
        lng
      })
    );
    const userLocation = getLocalStorage(constants.USER_LOCATION);

    openLocationBlock(userLocation);
  });
};

const setUserLocationByName = name => {
  const fetchUrl = `${process.env.GOOGLE_GEOCODE_LINK}?address=${name}&key=${process.env.GOOGLE_API_KEY}`;

  fethLocation(fetchUrl, "address").then(respond => {
    const { formattedAddress, lat, lng } = respond;

    localStorage.setItem(
      constants.USER_LOCATION,
      JSON.stringify({
        locationName: formattedAddress,
        lat,
        lng
      })
    );

    const userLocation = getLocalStorage(constants.USER_LOCATION);

    openLocationBlock(userLocation);
  });
};

const setMarkersTolocalStorage = mapTrigger => {
  const fetchUrl = `${location.origin}/?get_markers=markers`;

  fethLocation(fetchUrl, "markers").then(respond => {
    const { range, markers } = respond;

    localStorage.setItem(
      constants.MAP_MARKERS,
      JSON.stringify({
        range,
        markers
      })
    );

    mapTrigger.removeClass("disabled");
  });
};

const fetchDistances = fetchUrl =>
  fetch(fetchUrl)
    .then(json => json.json())
    .then(respond => {
      const {
        rows: {
          0: {
            elements: {
              0: {
                distance: { value: distanceValue }
              }
            }
          }
        }
      } = respond;

      return distanceValue;
    });
const makeNewMarkersArrayByDistance = (
  markers,
  newMarkersList,
  rangeInMeters,
  { lat, lng }
) =>
  Promise.all(
    markers.map(async markerData => {
      const {
        shop_data: { lat: markerLat, lng: markerLng }
      } = markerData;
      const fetchUrl = `${location.origin}/?origins=${lat},${lng}&destinations=${markerLat},${markerLng}`;
      let info = await fetchDistances(fetchUrl);

      if (info < rangeInMeters) {
        newMarkersList.push(markerData);
      }
    })
  );
const getCurrentLocationShops = async () => {
  const currentUserLocation = getLocalStorage(constants.USER_LOCATION);
  const { range, markers } = getLocalStorage(constants.MAP_MARKERS);
  const rangeInMeters = +range * 1000;
  let newMarkersList = [];

  if (markers.length) {
    await makeNewMarkersArrayByDistance(
      markers,
      newMarkersList,
      rangeInMeters,
      currentUserLocation
    );
  }

  return newMarkersList;
};

export {
  breakpoints,
  closeLocationBlock,
  constants,
  getCurrentLocationShops,
  getLocalStorage,
  matchBreakpoint,
  openLocationBlock,
  removeLocalStorageItem,
  setMarkersTolocalStorage,
  setUserLocationByCords,
  setUserLocationByName,
  slickItemsCounter
};
